import type { GraphQLSupporter } from '@sola/schema/dotcom/supporters/schema.generated.ts';

import {
  MOCK_SUPPORTER_DEPARTURE_SCENARIOS,
  MOCK_SUPPORTER_MIXED_COMMITMENTS,
  type MockSupporterDepartureScenario,
} from './mocks/supporters.ts';

const nextPublicUseMockSupporter =
  typeof process === 'undefined'
    ? undefined
    : process.env.NEXT_PUBLIC_USE_MOCK_SUPPORTER;

const nextPublicMockSupporterScenario =
  typeof process !== 'undefined'
    ? process.env.NEXT_PUBLIC_MOCK_SUPPORTER_SCENARIO
    : undefined;

const isMockSupporterDepartureScenario = (
  scenario?: string,
): scenario is MockSupporterDepartureScenario =>
  !!scenario && scenario in MOCK_SUPPORTER_DEPARTURE_SCENARIOS;

export const QUERY_KEYS = {
  dataPrimerReadOnly: 'dataPrimer',
  supporterPaymentSettings: 'supporterPaymentSettings',
  supporterDataStatus: 'supporterDataStatus',
  supporterPaymentMethods: 'supporterPaymentMethods',
  supporterCommitments: 'supporterCommitments',
  supporterDepartureSummary: 'supporterDepartureSummary',
  supporterGivingTotals: 'supporterGivingTotals',
  supporterAddress: 'supporterAddress',
  supporterGivingHistory: 'supporterGivingHistory',
  supporterPledges: 'supporterPledges',
  supporterTaxReceipts: 'supporterTaxReceipts',
  supporterDetails: 'supporterDetails',
  supporterGiftLimits: 'supporterGiftLimits',
  supporterPreferredUsername: 'supporterPreferredUsername',
  supporterContacts: 'supporterContacts',
  supporterContactPreferences: 'supporterContactPreferences',
  supporterRecentGiving: 'supporterRecentGiving',
  supporterRecentLetters: 'supporterRecentLetters',
  supporterRecentTransactions: 'supporterRecentTransactions',
  supporterVolunteerEvents: 'supporterVolunteerEvents',
  supporterWritingPreferences: 'supporterWritingPreferences',
};

export const MUTATION_KEYS = {
  makeAPaymentAdd: 'makeAPaymentAdd',
  paymentMethodRemove: 'paymentMethodRemove',
  commitmentPaymentPlanUpdate: 'commitmentPaymentPlanUpdate',
  departureSubUpdate: 'departureSubUpdate',
  addressUpdate: 'addressUpdate',
  contactInfoUpdate: 'contactInfoUpdate',
  contactPreferenceUpdate: 'contactPreferenceUpdate',
  preferredUsernameUpdate: 'preferredUsernameUpdate',
  passwordUpdate: 'passwordUpdate',
  volunteerSlotUpdate: 'volunteerSlotUpdate',
  letterWritingPreferencesUpdate: 'letterWritingPreferencesUpdate',
};

const getMockSupporter = () => {
  if (!nextPublicUseMockSupporter || nextPublicUseMockSupporter === 'false') {
    return null;
  }

  if (isMockSupporterDepartureScenario(nextPublicMockSupporterScenario)) {
    return MOCK_SUPPORTER_DEPARTURE_SCENARIOS[nextPublicMockSupporterScenario];
  }

  return MOCK_SUPPORTER_MIXED_COMMITMENTS;
};

export const MOCK_SUPPORTER = getMockSupporter();

export const updateMockSupporter = (
  updater: (supporter: GraphQLSupporter) => GraphQLSupporter,
): GraphQLSupporter | null => {
  if (!MOCK_SUPPORTER) {
    return null;
  }

  Object.assign(MOCK_SUPPORTER, updater(MOCK_SUPPORTER));
  return MOCK_SUPPORTER;
};
